import {useState } from 'react';
import Input from 'components/form/Input';
import Label from 'components/form/Label';
import Button from 'components/form/Button'
import Loader from "components/ui/Loader"
import { useAuth } from 'hooks/auth'
import AuthSessionStatus from 'components/auth/AuthSessionStatus'
import classNames from 'classnames'
import { useGoogleLogin } from '@react-oauth/google'
import {ErrorMessageAuth} from "components/form/ErrorMessage";

export default function LoginModal() {

  const { user, login, register, getVerifyToken, forgotPassword, authGoogle } = useAuth({
    middleware: 'guest',
  })

  const loginGoogle = useGoogleLogin({
    onSuccess: (tokenRes) => {
      console.log("tokenRes", tokenRes);
      authGoogle({ tokenRes, setErrors, setIsLoadingGoogle });
    }
  });

  const [email, setEmail] = useState(''),
    [password, setPassword] = useState(''),
    [error, setErrors] = useState(),
    [status, setStatus] = useState(null),
    [isLoading, setIsLoading] = useState(null),
    [isLoadingGoogle, setIsLoadingGoogle] = useState(false),
    [statusForm, setStatusForm] = useState('login');

  const submitForm = async event => {

    setIsLoading(true);

    event.preventDefault();

    setErrors();

    if (statusForm === "login") {

      login({ email, password, setErrors, setStatus, setIsLoading })

    } else if (statusForm === "register") {
      const password_confirmation = password;
      register({ email, password, password_confirmation, setIsLoading, setStatus, setErrors })
    } else if (statusForm === "forgot") {
      forgotPassword({ email, setErrors, setIsLoading, setStatus })
    }
  }

  function handleGetNewToken (){
    console.log("email", email);
    getVerifyToken({ email, setErrors, setIsLoading, setStatus })
  }

  return (
    <div className="flex items-center justify-center my-16">
      <div className="px-4 md:px-0 w-auto lg:w-6/12">
          <div className="relative flex flex-row justify-between overflow-hidden rounded-md bg-white w-full shadow-lg border">
            <div className="flex flex-col p-8 ">
              <span className="mb-2 text-2xl text-center font-bold text-gray-800">
                {statusForm === "forgot" ?
                  "Forgot Password?"
                  :
                  statusForm === "login" ?
                    "Sign in"
                    :
                    statusForm === "register" ? "Sign up" : "Forgot Password?"
                }
              </span>
              {statusForm !== "forgot" &&
                <>
                  <p className="text-gray-600 text-center">Log in to make the various changes!</p>
                  <p className="text-white text-center select-none">Enter the email address you used when you joined and we’ll send you instructions to reset your password.</p>
                </>
              }

              <div className={`${statusForm === "forgot" ? 'mt-0' : '-mt-14'}${" md:mt-4 flex flex-col gap-4"}`}>

                {statusForm !== "forgot" &&
                  <button disabled={isLoadingGoogle} onClick={() => loginGoogle()} className="flex flex-row justify-between w-full items-center h-12 rounded bg-gray-100 px-8 font-semibold text-pgray text-sm md:text-base shadow-none outline-none hover:bg-gray-200" tabIndex="0">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height="24" width="24"><path fill="#4285f4" d="M386 400c45-42 65-112 53-179H260v74h102c-4 24-18 44-38 57z"></path><path fill="#34a853" d="M90 341a192 192 0 0 0 296 59l-62-48c-53 35-141 22-171-60z"></path><path fill="#fbbc02" d="M153 292c-8-25-8-48 0-73l-63-49c-23 46-30 111 0 171z"></path><path fill="#ea4335" d="M153 219c22-69 116-109 179-50l55-54c-78-75-230-72-297 55z"></path></svg>
                    {!isLoadingGoogle && <>{statusForm == 'register' ? 'Sign up with google' : 'Sign in with google'} </>}
                    {isLoadingGoogle && <> <Loader /> Loading progress... </>}
                    <span className="text-gray-100 hover:text-gray-200 hover:bg-gray-200">g</span>
                  </button>
                }

                {statusForm === "forgot" &&
                  <p className="text-md text-gray-600 text-center px-4 lg:px-16">Enter the email address you used when you joined and we’ll send you instructions to reset your password.
                  </p>
                }

                {/* Session Status */}
                <div className='flex items-center space-x-1'>
                  <AuthSessionStatus className="mt-0" status={status} />
                  {status==="Please, check your email to verify your email"&&<button onClick={()=>handleGetNewToken()} className="text-blue-600 cursor-pointer text-left"> {"  "} or get new here</button> }
                </div>
                {/* Validation Errors */}
                <ErrorMessageAuth errors={error} />

                <form onSubmit={submitForm}>
                  <div>
                    <Label className="block text-gray-800" htmlFor="email">Email</Label>
                    <Input
                      type="email"
                      id="email"
                      maxLength="30"
                      autoFocus
                      required
                      autoComplete="off" role="presentation"
                      placeholder="julie@example.com"
                      value={email}
                      className={classNames(
                        !isLoading ? '' : '',
                        "w-full px-4 py-3 bg-white mt-2 border-gray-300 focus:border-8 focus:border-none outline outline-offset-2 outline-1"
                      )}
                      onChange={event =>
                        setEmail(event.target.value)
                      }
                    />
                  </div>

                  {statusForm !== "forgot" &&
                    <div className="mt-4">
                      <Label className="block text-gray-800" htmlFor="password">Mot de passe</Label>
                      <Input
                        type="password"
                        id="password"
                        minLength="6"
                        maxLength="26"
                        required
                        autoComplete="off"
                        placeholder="6+ characters"
                        role="presentation"
                        value={password}
                        className={classNames(
                          !isLoading ? '' : '',
                          "w-full px-4 py-3 bg-white mt-2 border-gray-300 focus:border-blue-0 focus:bg-white focus:outline-none"
                        )}
                        onChange={event =>
                          setPassword(event.target.value)
                        }
                      />
                    </div>
                  }

                  {statusForm === "login" && <div className="w-full flex flex-row justify-between py-4">
                    <a onClick={() => setStatusForm("register")} className="cursor-pointer text-sm text-blue-900">
                      Sign up now
                            </a>
                    <a onClick={() => setStatusForm("forgot")} className="cursor-pointer text-sm text-blue-800">
                      Forgot password?
                            </a>
                  </div>
                  }

                  {statusForm === "forgot" &&
                    <div className="w-full flex flex-row justify-end py-4">
                      {/* <a onClick={()=>setStatusForm("login")} className="cursor-pointer text-sm text-blue-900">
                              Se connecter
                            </a> */}
                    </div>
                  }

                  {statusForm === "register" &&
                    <div className="flex items-center pl-0 pt-4 text-sm md:font-sans text-xs text-gray-800">
                      <input
                        id="checked-checkbox"
                        type="checkbox"
                        value=""
                        required
                        className="w-4 h-4 mb-6 text-pblue bg-gray-100 rounded border-gray-300 focus:ring-pblue-400"
                      />
                      <span className="ml-1 inline">Creating an account means you’re okay with our
                                <a href="https://piano-piano.org/mentions-legales" target="_blank" data-test="Link">
                          <span className="underline "> Terms of Service, Privacy Policy </span> </a> {' '} and our default
                                <a href="https://piano-piano.org/mentions-legales" target="_blank" data-test="Link">
                          <span className="underline"> notification Settings. </span>
                        </a>
                      </span>
                    </div>
                  }
                  <Button
                    disabled={isLoading}
                    type="submit"
                    className={classNames(
                      !isLoading ? '' : 'bg-gray-400 opacity-50 cursor-not-allowed',
                      "duration-300 transform hover:-translate-y-1 w-full block w-full py-2.5 px-10 border rounded border-pbllue text-white font-medium bg-white bg-pblue mt-3"
                    )}
                  >
                    {!isLoading ?
                      statusForm === 'forget' ? 'Send Reset Instructions' : statusForm === 'login' ? 'Sign In' : statusForm === 'register' ? 'Create Account' : "Send Reset Instructions"
                      :
                      <> <Loader /> Current processing... </>
                    }
                  </Button>
                  <p className="mt-2 text-center"> <a href="/oppdb" className="text-blue-500 hover:text-pblue text-xs font-medium">Go to home</a></p>
                </form>

              </div>
            </div>
            {/* <CloseModal onClick={() => setOpen(false)}  /> */}
            {statusForm !== 'login' &&
              <button onClick={() => setStatusForm("login")} className="absolute top-2 left-2 z-10 flex h-8 w-8 items-center justify-center rounded-full font-semibold text-primary">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </button>
            }
          </div>
      </div>
    </div>
  );
}
